import React from 'react';
import { Container, Accordion } from 'react-bootstrap';

const FAQ: React.FC = () => {
  return (
    <Container className="py-5">
      <h2>Frequently Asked Questions</h2>
      <Accordion className="mt-4">
        <Accordion.Item eventKey="0">
          <Accordion.Header>How does CryptoSwappie work?</Accordion.Header>
          <Accordion.Body>
            CryptoSwappie is a cryptocurrency exchange platform that allows you to swap one cryptocurrency for another. Simply select your desired currencies, enter the amount, provide your wallet address, and complete the transaction.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>What are the exchange fees?</Accordion.Header>
          <Accordion.Body>
            Our exchange rates include all fees. The final amount you see is what you'll receive. There are no hidden fees or additional charges.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>How long do transactions take?</Accordion.Header>
          <Accordion.Body>
            Transaction times vary depending on the cryptocurrencies involved and network conditions. Most transactions are completed within 5-30 minutes.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>Is KYC required?</Accordion.Header>
          <Accordion.Body>
            No, CryptoSwappie does not require KYC for basic exchanges. We prioritize user privacy and anonymity.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>What is the minimum exchange amount?</Accordion.Header>
          <Accordion.Body>
            Minimum exchange amounts vary by cryptocurrency pair. The exact minimum will be displayed when you select your currencies.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>How secure is CryptoSwappie?</Accordion.Header>
          <Accordion.Body>
            We implement industry-standard security measures and do not store your cryptocurrencies. All transactions are processed directly through the blockchain.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default FAQ;